<template>
    <section class="section-banner">
        <!--  -->
        <el-carousel height="625px" @change="changeHandler" indicator-position="none">
            <el-carousel-item v-for="(item, index) in list" :key="index" class="items-box">
                <div class="item" :style="{backgroundImage: `url(${item.itemBg})`,cursor: item.url ? 'pointer':''}" @click="jumpUrl(item.url)">
                    <!-- 左侧内容 -->
                    <div class="cont">
                        <div class="text1">{{item.text1}}</div>
                        <div class="text2">{{item.text2}}</div>
                        <div class="btn" v-if="item.btn">

                            <a :href="webInfo.signUrl">
                                <el-button type="primary" class="btn1" @click="tryHandler">
                                    免费注册
                                </el-button>
                            </a>

                            <a :href="webInfo.loginUrl">
                                <el-button plain type="primary" class="btn2">
                                    登录
                                </el-button>
                            </a>
                        </div>
                    </div>

                </div>
            </el-carousel-item>
        </el-carousel>
    </section>
</template>

<script>
import 'animate.css';
import { MessageBox } from 'element-ui';

export default {
    props: {
        webType: {
            type: String,
            default: 'hzc',
        }
    },
    computed: {
        list(){
            return this.webInfo.home.banner || {};
        },
    },
    data () {
        return {};
    },
    methods: {
        jumpUrl(url){
            if(!url){
                return
            }
            window.open(url);
        },
        changeHandler (index) {
            this.list.forEach((item, bannerIndex) => {
                if (bannerIndex !== index) {
                    this.$set(
                        this.list[bannerIndex],
                        'animateController',
                        false
                    );
                } else {
                    this.$set(
                        this.list[bannerIndex],
                        'animateController',
                        true
                    );
                }
            });
        },
        tryHandler () {},
    },
    mounted () {
    },
};
</script>

<style lang="scss" scoped>
// @import '@/assets/css/hzc.scss';

.section-banner {
    .items-box {
        width: 100%;
        height: 100%;
    }
    .item {
        display: flex;
        position: relative;

        height: 625px;

        .img-item {
            width: 100%;
            // height: 100%;
            max-width: 1920px;
            margin: 0 auto;
        }

        .text {
            position: absolute;
            left: 50%;
            top: 50%;
        }

        .cont {
            width: 1200px;
            margin: 0 auto;
            margin-top: 140px;

            .text1 {
                font-size: 26px;
            }
            .text2 {
                font-size: 30px;
                font-weight: bold;
                margin-top: 30px;
            }

            .btn {
                margin-top: 80px;
                .el-button {
                    width: 140px;
                    height: 48px;
                    margin-right: 15px;
                    font-size: 20px;
                    padding-top: 11px;
                    padding-bottom: 14px;
                    
                }
            }

            .btn1 {
                a {
                    color: #fff;
                }
            }
        }
    }
}
</style>
